export const UPDATE_PROFILE_SETTINGS = "UPDATE_PROFILE_SETTINGS";
export const UPDATE_PROFILE_SETTINGS_INDICATOR = "UPDATE_PROFILE_SETTINGS_INDICATOR";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_INDICATOR = "UPDATE_PASSWORD_INDICATOR";